import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { Tour } from 'src/app/model/tour/tour';
import { ImmoIPTourOrderChangesService } from 'src/app/services/immo-ip-placer-offline-changes/immo-ip-tour-order-changes/immo-ip-tour-order-changes.service';

export class ImmoIPPlacerTourOrderHelper {
  private constructor() {}

  public static async applyLocalTourOrderChanges(
    tour: Tour,
    immoIPTourOrderChangesService: ImmoIPTourOrderChangesService
  ): Promise<void> {
    if (tour == null || !CollectionHelper.isPopulated(tour.tourItems)) {
      return;
    }

    const tourOrderChangesObject = await immoIPTourOrderChangesService.getObject(
      tour.id
    );
    if (
      tourOrderChangesObject == null ||
      !CollectionHelper.isPopulated(
        tourOrderChangesObject.tourItemIdSequenceNumberPairs
      )
    ) {
      return;
    }

    const pairMap = new Map<number, number>(
      tourOrderChangesObject.tourItemIdSequenceNumberPairs.map(p => [
        p.tourItemId,
        p.sequenceNumber
      ])
    );
    tour.tourItems.forEach(ti => {
      const sequenceNumber = pairMap.get(ti.id);
      ti.sequenceNumber =
        sequenceNumber == null ? ti.sequenceNumber : sequenceNumber;
    });
    tour.tourItems.sort((ti1, ti2) => ti1.sequenceNumber - ti2.sequenceNumber);
  }
}
